import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function AGentleGoodbye() {
  return <section id="hero" className="relative min-h-screen w-full overflow-hidden bg-[#fafaf8] px-6 py-24 md:px-16">
      <div className="absolute inset-0 bg-gradient-to-br from-[#fafaf8] via-[#f0faf9] to-[#e0f5f3]" />

      <div className="relative z-10 mx-auto grid min-h-[80vh] max-w-7xl items-center gap-12 md:grid-cols-2">
        <div>
          <div className="mb-6 inline-flex items-center rounded-full border border-[rgba(2,128,144,0.2)] bg-[#e0f5f3] px-4 py-2 text-xs font-semibold uppercase tracking-[0.1em] text-[#028090]">
            Simplifying Healthcare Navigation
          </div>

          <h1 className="mb-4 font-serif text-5xl leading-tight text-[#0a2540] md:text-7xl">
            The appointment
            <br />
            you keep
            <br />
            <em className="text-[#028090]">skipping</em>? Booked.
          </h1>

          <p className="mb-6 font-serif text-xl italic text-[#00A896]">
            May it be easy for you.
          </p>

          <p className="mb-10 max-w-xl text-lg leading-8 text-[#4a5f6b]">
            KolayHealth finds the right appointment, at the right time, near
            you — and books it in seconds. No portals. No phone calls. No
            friction.
          </p>

          <div className="flex flex-wrap gap-4">
            <Button asChild className="rounded-full bg-[#028090] px-8 py-6 text-base font-semibold text-white hover:bg-[#0a2540]">
              <Link to="#patients">I'm a Patient</Link>
            </Button>

            <Button asChild variant="outline" className="rounded-full border border-[rgba(10,37,64,0.18)] px-8 py-6 text-base font-semibold text-[#0a2540]">
              <Link to="#providers">I'm a Provider</Link>
            </Button>
          </div>

          <div className="mt-12 flex flex-wrap gap-8 border-t border-[rgba(2,128,144,0.14)] pt-8">
            <div>
              <div className="text-sm font-semibold text-[#0a2540]">
                Seconds to book
              </div>
              <div className="text-sm text-[#4a5f6b]">No forms, no calls</div>
            </div>

            <div>
              <div className="text-sm font-semibold text-[#0a2540]">
                Calendar-aware
              </div>
              <div className="text-sm text-[#4a5f6b]">Fits around your life</div>
            </div>

            <div>
              <div className="text-sm font-semibold text-[#0a2540]">
                Privacy-first
              </div>
              <div className="text-sm text-[#4a5f6b]">
                No medical records needed
              </div>
            </div>
          </div>
        </div>

        <div className="relative flex justify-center">
          <div className="w-full max-w-[320px] rounded-[40px] bg-[#0a2540] p-4 shadow-2xl">
            <div className="min-h-[560px] rounded-[28px] bg-white overflow-hidden">
              <div className="flex justify-between bg-[#f5f5f5] px-5 py-3 text-xs font-semibold text-[#555]">
                <span>9:41</span>
                <span>● WiFi </span>
              </div>

              <div className="m-3 rounded-2xl bg-[#0a2540] p-4">
                <div className="mb-3 flex items-center gap-2">
                  <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#028090] text-sm font-bold text-white">
                    K
                  </div>
                  <div className="text-[10px] font-semibold tracking-[0.06em] text-white/50">
                    KOLAYHEALTH
                  </div>
                  <div className="ml-auto text-[10px] text-white/30">now</div>
                </div>

                <div className="text-sm leading-6 text-white/85">
                  Hi Jane! You're overdue for your annual mammogram. We found an
                  opening nearby that fits your schedule and takes your
                  insurance.
                </div>

                <button className="mt-3 w-full rounded-lg bg-[#028090] px-4 py-2 text-sm font-semibold text-white">
                  Tap to review →
                </button>
              </div>

              <div className="mx-3 mb-3 rounded-2xl border border-[#e0f5f3] bg-[#f0faf9] p-4">
                <div className="mb-2 text-[10px] font-bold uppercase tracking-[0.1em] text-[#028090]">
                  ✦ Best match for you
                </div>
                <div className="text-sm font-bold text-[#0a2540]">
                  RadNet Women's Imaging
                </div>
                <div className="mb-3 text-xs text-[#4a5f6b]">
                  Mammogram Screening
                </div>
                <div className="mb-1 text-xs text-[#4a5f6b]">
                   Tue Dec 3 · 2:00 PM
                </div>
                <div className="mb-1 text-xs text-[#4a5f6b]">
                   0.8 mi · 8 min drive
                </div>
                <div className="mb-3 text-xs text-[#4a5f6b]">
                   Blue Cross PPO · $0 copay
                </div>
                <button className="w-full rounded-lg bg-[#028090] px-4 py-2 text-sm font-bold text-white">
                  Book This Appointment →
                </button>
              </div>

              <div className="mx-3 mb-3 rounded-2xl bg-gradient-to-br from-[#028090] to-[#02C39A] p-4 text-white">
                <div className="mb-1 text-2xl"></div>
                <div className="text-sm font-bold">You're all set, Jane!</div>
                <div className="mb-3 text-xs text-white/80">Done in seconds.</div>
                <div className="space-y-1 text-xs text-white/85">
                  <div> Added to your calendar</div>
                  <div> Reminders set automatically</div>
                  <div> Confirmation sent</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}